import { createFileRoute } from '@tanstack/react-router';
import SMSConsentPage from '../views/consent/sms';

export const Route = createFileRoute('/consent/sms/')({
  component: SMSConsentPage,
});
